import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { ContentAssetRow } from "./types";

// GET /api/admin/content/folders
//
// Phase 7 sub-bucket 13. Flat list of active (non-archived) folder rows,
// alphabetised by title. Drives the Move dialog destination picker. Kept
// off `queryKeys.content.list()` so list filter churn doesn't refetch the
// dialog source; folder writes invalidate this key via use-create-asset's
// onSuccess (created folders mutate this set too — see audit comments in
// the mutation hooks).
export function useContentFolders() {
  return useQuery<ContentAssetRow[], ApiClientError>({
    queryKey: queryKeys.content.folders(),
    queryFn: () => apiFetch<ContentAssetRow[]>("/admin/content/folders"),
  });
}
